var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManufacturer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f93964;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M206.778,597.731h0a8,8,0,0,0-8,8h0a7.96,7.96,0,0,0,1.265,4.315c1.322-1.19,2.685-2.421,3.572-3.191l1.667-1.445.718.754.73.742-1.5,1.62c-.81.874-2.11,2.223-3.359,3.523a7.963,7.963,0,0,0,4.9,1.682h0a8,8,0,0,0,8-8h0A8,8,0,0,0,206.778,597.731Zm7.036,8.622-.551.561-2.081,1.984a.337.337,0,0,1-.174.085.275.275,0,0,1-.139-.086c-.394-.37-.787-.763-1.164-1.145l-.283-.282a1.113,1.113,0,0,0-.172-1.431,1.175,1.175,0,0,0-.287-.224,1.086,1.086,0,0,0-1.039.038,3.038,3.038,0,0,0-.413.341c-.209-.219-.434-.458-.666-.7-.271-.285-.546-.574-.817-.856a3.053,3.053,0,0,0,.431-1.367,2.52,2.52,0,0,0-1.438-2.439,3.928,3.928,0,0,0-1.362-.4.263.263,0,0,1-.078-.5,4.33,4.33,0,0,1,1.354-.388,4.736,4.736,0,0,1,2.831.571,3.782,3.782,0,0,1,1.089.83c.716.79,1.436,1.561,2.047,2.212a.465.465,0,0,1,.156.376c-.007.106-.007.209-.005.315l0,.12c0,.478.216.707.682.718h.04c.13,0,.6,0,.648,0a.309.309,0,0,1,.238.1c.2.207.4.417.6.625.182.186.363.372.542.557C213.963,606.136,213.925,606.238,213.814,606.353Z",
    transform: "translate(-198.778 -597.731)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManufacturer);
export default __webpack_public_path__ + "static/media/manufacturer.86246d412707c87e3b2aca6a761c23c4.svg";
export { ForwardRef as ReactComponent };